import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, Analytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyD4FJisCAruOy-TjyYkyXUzaakS6phdk8c",
  authDomain: "cheyenne-rmed.firebaseapp.com",
  projectId: "cheyenne-rmed",
  storageBucket: "cheyenne-rmed.firebasestorage.app",
  messagingSenderId: "1016990228388",
  appId: "1:1016990228388:web:b0ac6e63bd3f5de72e6b31",
  measurementId: "G-8LEWFCVDK5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Auth
const auth = getAuth(app);

// Initialize Analytics (only works in browser)
let analytics: Analytics | null = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Helper function to log analytics events
const trackEvent = (eventName: string, params?: Record<string, string | number>) => {
  if (analytics) {
    logEvent(analytics, eventName, params);
  }
};

export { app, db, auth, analytics, trackEvent };
